import React, { useState, useEffect } from 'react';
import axios from 'axios';

//const API = process.env.REACT_APP_API_URL || 'https://sohaibenterprises.cloud/api';
const API = 'http://localhost:5000/api';
const InventoryTab = () => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [editingAlert, setEditingAlert] = useState(null);
  const [alertValue, setAlertValue]     = useState('');
  const [error, setError]               = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchInventory = async () => {
    try {
      const res = await axios.get(`${API}/tape/inventory`, { headers });
      setInventory(res.data.data || []);
    } catch {
      setError('Failed to load inventory');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchInventory(); }, []);

  const handleUpdateAlert = async (product_id) => {
    try {
      await axios.put(`${API}/tape/inventory/low-stock-alert/${product_id}`, { low_stock_alert: alertValue }, { headers });
      setEditingAlert(null);
      fetchInventory();
    } catch {
      setError('Failed to update alert');
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '60px', color: '#7f8c8d' }}>Loading...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#2c3e50', margin: 0 }}>📦 Inventory</h2>
      </div>

      {error && (
        <div style={{ background: '#fdecea', border: '1px solid #e74c3c', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#e74c3c' }}>
          {error}
        </div>
      )}

      {/* ── INVENTORY CARDS ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
        {inventory.map(item => {
          const isLow = item.current_stock <= item.low_stock_alert;
          return (
            <div key={item.id} style={{
              background: 'white', borderRadius: '16px', padding: '24px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              borderLeft: `4px solid ${isLow ? '#e74c3c' : '#27ae60'}`
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div>
                  <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#2c3e50', margin: '0 0 4px 0' }}>{item.product_name}</h3>
                  <span style={{ fontSize: '13px', color: '#7f8c8d', textTransform: 'capitalize' }}>{item.type} use</span>
                </div>
                <span style={{
                  padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600',
                  background: isLow ? '#fdecea' : '#eafaf1',
                  color: isLow ? '#e74c3c' : '#27ae60'
                }}>
                  {isLow ? '⚠️ Low' : '✅ OK'}
                </span>
              </div>

              <div style={{ fontSize: '36px', fontWeight: '700', color: isLow ? '#e74c3c' : '#2c3e50', marginBottom: '8px' }}>
                {item.current_stock}
                <span style={{ fontSize: '16px', color: '#7f8c8d', fontWeight: '500' }}> rolls</span>
              </div>

              <div style={{ fontSize: '13px', color: '#7f8c8d', marginBottom: '16px' }}>
                Size: {item.size_inches}" | Alert at: {item.low_stock_alert} rolls
              </div>

              {/* ── Edit alert threshold ── */}
              {editingAlert === item.product_id ? (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <input
                    type="number"
                    value={alertValue}
                    onChange={e => setAlertValue(e.target.value)}
                    style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}
                  />
                  <button
                    onClick={() => handleUpdateAlert(item.product_id)}
                    style={{ padding: '8px 14px', background: '#27ae60', border: 'none', borderRadius: '8px', color: 'white', cursor: 'pointer', fontWeight: '600' }}
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setEditingAlert(null)}
                    style={{ padding: '8px 14px', background: '#f0f0f0', border: 'none', borderRadius: '8px', color: '#555', cursor: 'pointer' }}
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => { setEditingAlert(item.product_id); setAlertValue(item.low_stock_alert); }}
                  style={{ padding: '8px 16px', background: '#f8f9fa', border: '1px solid #ddd', borderRadius: '8px', color: '#555', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                >
                  ✏️ Edit Alert Threshold
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InventoryTab;